export default function AMDGoogleCloudLogo() {
  return (
    <svg            
      viewBox="0 0 242 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="AMD_Google_Logo" clipPath="url(#clip0_30_67)">
        <path
          id="Vector"
          d="M8.28 6.54002L10.71 12.46H6.08L8.28 6.54002ZM6.05 2.90002L0 18.14H3.97L5.09 15.12H11.81L13.05 18.13H17.09L10.4 2.90002H6.06H6.05Z"
          fill="#6A6B6D"
        />
        <path
          id="Vector_2"
          d="M31.73 2.89001H35L35.01 18.12H31.26L31.25 8.61001L27.2 13.39H26.62L22.56 8.61001L22.57 18.13H18.82L18.81 2.90001L22.08 2.89001L26.91 8.54001L31.73 2.89001Z"
          fill="#6A6B6D"
        />
        <path
          id="Vector_3"
          d="M44.49 2.88C49.98 2.88 52.8 6.34 52.81 10.51C52.82 14.68 50.08 18.11 44.08 18.11H37.86V2.88H44.5H44.49ZM41.61 15.32H44.06C47.83 15.32 48.95 12.72 48.95 10.49C48.95 7.88 47.56 5.67 44.01 5.67H41.61V15.32Z"
          fill="#6A6B6D"
        />
        <path
          id="Vector_4"
          d="M68.02 6.47999H60.26L55.53 1.69999L72.74 1.67999L72.75 19.12L68.02 14.33V6.47999Z"
          fill="#6A6B6D"
        />
        <path
          id="Vector_5"
          d="M60.26 14.34V7.44L55.4 12.38V19.28L62.21 19.27L67.07 14.34H60.26Z"
          fill="#6A6B6D"
        />
        <path
          id="Vector_6"
          d="M112.23 11.28V8.68H120.93C121.02 9.14 121.07 9.68 121.07 10.27C121.07 12.22 120.54 14.63 118.82 16.35C117.15 18.09 115.02 19.02 112.19 19.02C106.95 19.02 102.53 14.76 102.53 9.51C102.53 4.26 106.93 0 112.17 0C115.07 0 117.14 1.13 118.69 2.62L116.86 4.45C115.75 3.41 114.24 2.6 112.17 2.6C108.34 2.6 105.35 5.69 105.35 9.52C105.35 13.35 108.35 16.43 112.18 16.43C114.66 16.43 116.08 15.43 116.98 14.52C117.72 13.78 118.2 12.72 118.39 11.28H112.22H112.23Z"
          fill="#6A6B6D"
        />
        <g id="Group">
          <path
            id="Vector_7"
            d="M131.63 12.89C131.63 10.69 130.03 9.18002 128.17 9.18002C126.31 9.18002 124.71 10.69 124.72 12.89C124.73 15.09 126.32 16.6 128.18 16.6C130.04 16.6 131.64 15.07 131.63 12.89ZM134.33 12.89C134.33 16.42 131.57 19.02 128.19 19.02C124.81 19.02 122.04 16.42 122.04 12.9C122.04 9.38002 124.8 6.77002 128.18 6.77002C131.56 6.77002 134.33 9.34002 134.33 12.89Z"
            fill="#6A6B6D"
          />
          <path
            id="Vector_8"
            d="M145.05 12.88C145.05 10.68 143.45 9.17001 141.59 9.17001C139.73 9.17001 138.13 10.68 138.14 12.88C138.15 15.08 139.74 16.59 141.6 16.59C143.46 16.59 145.06 15.06 145.05 12.88ZM147.74 12.88C147.74 16.41 144.98 19.01 141.6 19.01C138.22 19.01 135.45 16.41 135.45 12.89C135.45 9.37001 138.21 6.76001 141.59 6.76001C144.97 6.76001 147.74 9.33001 147.74 12.88Z"
            fill="#6A6B6D"
          />
          <path
            id="Vector_9"
            d="M158.23 12.89C158.23 10.73 156.79 9.15999 154.96 9.15999C153.13 9.15999 151.55 10.74 151.55 12.9C151.55 15.06 153.11 16.59 154.96 16.59C156.81 16.59 158.23 15.03 158.23 12.9M160.59 7.10999V18.11C160.6 22.64 157.93 24.49 154.78 24.5C151.81 24.5 150.02 22.51 149.35 20.88L151.69 19.9C152.11 20.9 153.13 22.08 154.78 22.08C156.8 22.08 158.05 20.82 158.05 18.48V17.6H157.96C157.36 18.34 156.2 18.99 154.74 18.99C151.68 18.99 148.87 16.33 148.87 12.89C148.87 9.44999 151.67 6.73999 154.74 6.73999C156.2 6.73999 157.36 7.38999 157.97 8.10999H158.06V7.10999H160.61H160.59Z"
            fill="#6A6B6D"
          />
        </g>
        <path
          id="Vector_10"
          d="M165.15 0.679993H162.46V18.62H165.15V0.679993Z"
          fill="#6A6B6D"
        />
        <g id="Group_2">
          <path
            id="Vector_11"
            d="M169.12 12.68L174.59 10.4C174.29 9.62999 173.38 9.09999 172.32 9.09999C170.95 9.09999 169.05 10.31 169.12 12.67M175.55 14.88L177.64 16.27C176.97 17.27 175.34 18.99 172.54 18.99C169.06 18.99 166.46 16.3 166.46 12.87C166.46 9.22999 169.08 6.73999 172.23 6.73999C175.38 6.73999 176.97 9.26999 177.48 10.63L177.76 11.33L169.57 14.72C170.2 15.95 171.17 16.58 172.54 16.57C173.91 16.56 174.86 15.9 175.55 14.87"
            fill="#6A6B6D"
          />
          <path
            id="Vector_12"
            d="M191.89 18.99C189.44 18.99 187.39 18.17 185.74 16.51C184.08 14.86 183.25 12.79 183.25 10.31C183.25 7.83 184.07 5.77 185.73 4.11C187.39 2.45 189.44 1.62 191.88 1.62C194.32 1.62 196.42 2.52 197.99 4.33L196.51 5.77C195.38 4.36 193.84 3.66 191.89 3.66C190.08 3.66 188.55 4.27 187.31 5.5C186.07 6.72 185.44 8.33 185.44 10.31C185.44 12.29 186.07 13.89 187.31 15.11C188.56 16.33 190.09 16.94 191.9 16.94C193.9 16.94 195.6 16.13 197.01 14.52L198.5 16.01C197.74 16.92 196.79 17.65 195.65 18.18C194.5 18.72 193.26 18.98 191.91 18.98"
            fill="#6A6B6D"
          />
        </g>
        <path
          id="Vector_13"
          d="M202.52 1.98999H200.38V18.61H202.52V1.98999Z"
          fill="#6A6B6D"
        />
        <g id="Group_3">
          <path
            id="Vector_14"
            d="M207.6 15.9C208.34 16.65 209.21 17.03 210.21 17.02C211.21 17.01 212.09 16.64 212.82 15.89C213.55 15.14 213.92 14.14 213.92 12.91C213.92 11.68 213.55 10.68 212.81 9.93005C212.07 9.18005 211.2 8.81005 210.2 8.81005C209.2 8.81005 208.32 9.19005 207.59 9.94005C206.86 10.69 206.49 11.69 206.49 12.92C206.49 14.15 206.86 15.15 207.59 15.9M206 8.59005C207.1 7.44005 208.5 6.86005 210.2 6.86005C211.9 6.86005 213.3 7.43005 214.4 8.59005C215.5 9.74005 216.05 11.19 216.05 12.92C216.05 14.65 215.5 16.1 214.41 17.25C213.31 18.4 211.91 18.98 210.21 18.98C208.51 18.98 207.11 18.41 206.01 17.25C204.91 16.1 204.36 14.66 204.36 12.92C204.36 11.18 204.91 9.74005 206 8.59005Z"
            fill="#6A6B6D"
          />
          <path
            id="Vector_15"
            d="M227.88 18.59H225.84V17.01H225.75C225.43 17.55 224.93 18.01 224.26 18.39C223.59 18.77 222.89 18.96 222.15 18.96C220.73 18.96 219.65 18.53 218.91 17.66C218.17 16.79 217.8 15.63 217.8 14.18V7.21002H219.93V13.83C219.93 15.95 220.87 17.01 222.75 17.01C223.63 17.01 224.35 16.65 224.91 15.94C225.47 15.23 225.74 14.41 225.74 13.48V7.21002H227.87V18.59H227.88Z"
            fill="#6A6B6D"
          />
          <path
            id="Vector_16"
            d="M235.47 17.01C236.48 17.01 237.33 16.64 238.03 15.89C238.73 15.15 239.08 14.15 239.08 12.89C239.08 11.63 238.73 10.64 238.02 9.90002C237.31 9.16002 236.46 8.79002 235.45 8.79002C234.44 8.79002 233.61 9.17002 232.9 9.92002C232.19 10.67 231.83 11.67 231.83 12.9C231.83 14.13 232.19 15.13 232.9 15.88C233.61 16.63 234.46 17.01 235.45 17M235.12 18.96C233.65 18.96 232.38 18.38 231.31 17.22C230.24 16.06 229.71 14.62 229.7 12.9C229.69 11.18 230.23 9.74002 231.3 8.58002C232.37 7.42002 233.64 6.84002 235.11 6.84002C235.98 6.84002 236.75 7.02002 237.44 7.40002C238.13 7.77002 238.64 8.23002 238.99 8.79002H239.08L238.99 7.21002V1.96002H241.12V18.58H239.09V17H239C238.66 17.56 238.14 18.02 237.46 18.39C236.77 18.76 235.99 18.95 235.13 18.95"
            fill="#6A6B6D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_30_67">
          <rect width="241.13" height="24.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
